module.exports = __webpack_public_path__ + "static/media/DonateCarousel_1.5ae16dbd.jpeg";